import { Avatar, Dropdown, MenuProps } from 'antd'
import { useAuth } from '@forwardflow/context/AuthContext'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { useNavigate } from 'react-router-dom'

export const Account = () => {
   const {
      auth: { user },
   } = useAuth()
   const navigate = useNavigate()

   function logout() {
      const isTourDone = LocalStorage.get('isTourDone')
      const isCampaignTourDone = LocalStorage.get('isCampaignTourDone')

      LocalStorage.clear()

      if (isTourDone) LocalStorage.put('isTourDone', isTourDone)
      if (isCampaignTourDone)
         LocalStorage.put('isCampaignTourDone', isCampaignTourDone)

      navigate('/logout')
      window.location.reload()
   }

   const items: MenuProps['items'] = [
      {
         label: (
            <div className="py-1 font-semibold text-[16px]" onClick={logout}>
               Logout
            </div>
         ),
         key: '0',
      },
   ]

   return (
      <Dropdown menu={{ items }} trigger={['click']}>
         <div className="h-9 w-9 lg:h-[52px] lg:w-[52px] rounded-4xl bg-black-shade flex items-center cursor-pointer">
            <Avatar
               className="text-[18px] shrink-0 lg:text-[24px] w-9 h-9 lg:w-[55px] lg:h-[55px] font-medium bg-[#383838]"
               src={user?.avatar || null}
            >
               {user?.firstName?.charAt(0)}
            </Avatar>
            {/* <div className="items-center justify-between flex-1 hidden lg:flex">
          <span className="flex-1 ml-5 overflow-hidden font-semibold capitalize text-ellipsis whitespace-nowrap">
            {user?.firstName}
          </span>
          <Icon name="arrow-down" className="mx-5" />
        </div> */}
         </div>
      </Dropdown>
   )
}
